export const unwrapQueryParam = (param: string | (string | null)[] | null): string => {
    if (typeof param === "string") {
        return param as string
    } else {
        return ""
    }
}
